/** What two select options are compared by: authors may vary case and padding, not meaning. */
export function selectOptionKey(option) {
    return option.trim().toLowerCase();
}
//# sourceMappingURL=select-option-key.js.map